import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Row, Col, Spin, Typography, List, Button} from 'antd'
import { courseActions } from '../../redux/reducers/course';
import { CheckCircleTwoTone, SyncOutlined, MinusCircleTwoTone } from '@ant-design/icons';


const {Title} = Typography;


const LessonList = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user)
    const course = useSelector(state => state.course.course);
    const userCourse = useSelector(state => state.course.userCourse);
    const activeLesson = useSelector(state => state.course.activeLesson);
    const loading = useSelector((state) => state.course.isFetching);


    if(loading){
        return(
            <Row justify="center">
                <Col>
                    <Spin
                        size="large"
                        spinning={loading}
                        delay={100}
                    ></Spin>
                </Col>
            </Row>
        )
    }

    const lessonMarking = (lessonId, lessonTitle) => {

        if (userCourse.UserLessons.find(obj => obj.lessonId == lessonId && obj.status == "completed")){
            return (
                <Button 
                    type="text"
                    icon={<CheckCircleTwoTone  size="large" 
                            twoToneColor="#52c41a" 
                            style={{ fontSize: '16px', 
                            float:"left"}}/>}
                    block>
                        {lessonTitle}
                </Button>   
            )
        }else{
            return ( 
                <Button 
                    type="text"
                    icon={<MinusCircleTwoTone  size="large" 
                            style={{ fontSize: '16px', 
                            float:"left"}}/>}
                    block>
                        {lessonTitle}
                </Button>   
            ) 
        }


    }

    return (
        <List
            size="small"
            header={<Title style={{padding:8}} level={5}>Lessons</Title>}
            bordered
            dataSource={course.lessons}
            renderItem={item => 
                (
                    <List.Item
                        key={item.id}
                        onClick={()=>{
                            dispatch(courseActions.setActiveLesson(user.jwt, item.id))
                        }}
                    >
                        {
                            activeLesson.id == item.id 
                            ?
                            <Button 
                                type="text"
                                icon={<SyncOutlined  rotate={180} size="large" 
                                        twoToneColor="#52c41a" 
                                        style={{ fontSize: '16px', 
                                        float:"left"}}/>}
                                block>
                                    {item.title}
                            </Button>   
                            :
                            lessonMarking(item.id, item.title)
                        }
                        
                            
                    </List.Item>
                )
            }
            style={{
                borderRadius: 10, 
                marginBottom: 25,
                boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)" 
            }}
        />
    )
}

export default LessonList
